














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class NumericButton extends Vue {
  @Prop({ required: true }) public value: number;
  @Prop({ required: true }) public scoreLabel!: number;
  @Prop({ default: null }) public scoreBackgroundColor!: string;
  @Prop({ default: false }) public whiteMode!: boolean;
  @Prop({ default: '' }) public accessibleLabel!: string;

  public get accessibleName(): string {
    const option = this.$t('generic.scoreOption', { score: this.scoreLabel }) as string;
    return this.accessibleLabel ? `${this.accessibleLabel}: ${option}` : option;
  }

  public get isSelectedScore(): boolean {
    return this.scoreLabel === this.value;
  }

  public get backgroundColor(): string {
    return this.scoreBackgroundColor ?? null;
  }

  public get color(): string {
    return this.scoreBackgroundColor ? `#ffffff` : null;
  }

  public get style(): Record<string, string> {
    return {
      backgroundColor: this.backgroundColor,
      color: this.color,
    };
  }

  public selectScore(): void {
    this.$emit('input', this.scoreLabel);
  }
}
